module.exports = __webpack_public_path__ + "img/company5.30a40cb7.png";